import { useState } from "react";
import { TextField } from '@mui/material';
import { StandardTextFieldProps } from '@mui/material/TextField';

interface ITextFieldFloat extends Omit<StandardTextFieldProps, "value" | "onChange"> {
	value: number;
	onChange: (newValue: number) => void;
}

export default function TextFieldFloat({
	value = 0,
	onChange = () => {},
	...props
}: ITextFieldFloat) {
	const [state, setState] = useState(value.toString());

	function updateValue(inputString: string) {
		const strValue = inputString.trim().replace(/[^0-9.,]+/gu, "").replace(",", ".");
		const numValue = parseFloat(strValue);

		if (isNaN(numValue)) {
			onChange(0);
			setState("");
		} else {
			const lastSign = strValue[strValue.length - 1];
			const lastSignTest = lastSign === "." || lastSign === ",";

			onChange(numValue);
			setState(lastSignTest ? strValue : numValue.toString());
		}
	}

	return <TextField
		size="small"
		inputProps={{
			autoComplete: "off",
		}}
		onChange={event => updateValue(event.target.value)}
		value={state}
		{ ...props }
	/>;
}
